import { Record } from 'immutable';

import { construct, fields} from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    type: null,
    amount: 0,
    customer: null,
    success: false,
    processing: false
};


class PaymentResponse extends Record(defaults) { // eslint-disable-line new-cap

    static fromJSON (json = {}) {
        return construct(PaymentResponse, json, {
            id: fields.string,
            type: fields.string,
            amount: fields.number,
            customer: fields.string,
            success: fields.boolean
        });
    }
}

export default PaymentResponse;



// WEBPACK FOOTER //
// ./src/records/payment/PaymentResponse.js